import React, { Suspense, useState } from "react";
import { Route, Switch } from "react-router-dom";
import RoleClienteServices, { UserData } from "services/axios/role_cliente/RoleClienteServices";
import { useDialog } from "muibox";
import { defaultAlertOptions } from "config/muibox";
import { mensajesGenerales } from "config/mensajes";

import { LoadingFallback } from "components/LoadingFallback";

const DashboardPage = React.lazy(() => import('pages/role_cliente/dashboard/DashboardPage'));
const CertificadosPage = React.lazy(() => import('pages/role_cliente/certificados/CertificadosPage'));
// const CertificadoPDF = React.lazy(() => import('pages/role_cliente/certificados/CertificadoPDF'));
const ServiciosPage = React.lazy(() => import('pages/role_cliente/servicios/ServiciosPage'));
const DetalleServicioPage = React.lazy(() => import('pages/role_cliente/servicios/DetalleServicioPage'));
const EncuestaServicioPage = React.lazy(() => import('pages/role_cliente/servicios/EncuestaServicioPage'));
const ProductosHabilitadosPage = React.lazy(() => import('pages/role_cliente/productos_habilitados/ProductosHabilitadosPage'));

interface UserDataContext {
  userData: UserData | null;
  setUserData: (userData: UserData) => void;
}

export const UserDataContext = React.createContext<UserDataContext | null>(null);

const mensajes = {
  ...mensajesGenerales,
}

export default () => {
  const dialog = useDialog();
  const [userData, setUserData] = useState<UserData | null>(null);
  const contextValue = { userData, setUserData }; //se usa esto para poder actualizarlo desde un child

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const _userData = await RoleClienteServices.fetchUserData();
        setUserData(_userData);
      } catch (error) {
        error && //if not cancelled 
          dialog.alert({
            ...defaultAlertOptions,
            title: mensajes.formValidacion.haOcurridoUnError,
            message: `${error.message}`
          });
      }
    }
    fetchData();
  }, [dialog]);

  return (
    <Suspense fallback={<LoadingFallback backgroundColor="#ebebeb" />}>
      <UserDataContext.Provider value={contextValue}>
        <Switch>
          <Route path="/" exact component={DashboardPage} />
          <Route path="/cliente/" exact component={DashboardPage} />
          <Route path="/cliente/dashboard" component={DashboardPage} />
          <Route path="/cliente/certificados" component={CertificadosPage} exact />
          {/* <Route path="/cliente/certificados/:id/pdf" component={CertificadoPDF} /> */}
          <Route path="/cliente/servicios" component={ServiciosPage} exact />
          <Route path="/cliente/servicios/:id" component={DetalleServicioPage} exact />
          <Route path="/cliente/servicios/:id/encuesta" component={EncuestaServicioPage} />
          <Route path="/cliente/productos/habilitados" component={ProductosHabilitadosPage} />
        </Switch>
      </UserDataContext.Provider>
    </Suspense>
  );
};
